import React from "react"
import styled from "styled-components"
import GettingStarted from "../web/gettingstarted";
import ContactsAndLists from "../web/contactsandlists";
import Campaigns from "../web/campaigns";
import MobilePages from "../web/mobilepages";
import LeadCapture from "../web/leadcapture";
import Library from "../web/library";
import AccountManagement from "../web/accountmanagement";
import BuilderElements from "../web/builderelements";

import Rocket from '../../images/icons/sidebar/web/rocket.svg'
import Contacts from '../../images/icons/sidebar/web/contacts.svg'
import CampaignsIcon from '../../images/icons/sidebar/web/campaigns.svg'
import MobilePageIcon from '../../images/icons/sidebar/web/mobilepages.svg'
import LeadCaptureIcon from '../../images/icons/sidebar/web/leadcapture.svg'
import LibraryIcon from '../../images/icons/sidebar/web/library.svg'
import AccountManagementIcon from '../../images/icons/sidebar/web/accountmanagement.svg'
import DragAndDropIcon from '../../images/icons/sidebar/web/drag-and-drop.svg'

const SideBarMenu = ({ expandAll, toggleExpandAll }) => {
  return (
    <SideBarMenuWrapper>
      <GettingStarted expandAll={expandAll} icon={Rocket} toggleExpandAll={toggleExpandAll} />
      <ContactsAndLists expandAll={expandAll} icon={Contacts} toggleExpandAll={toggleExpandAll}/>
      <Campaigns expandAll={expandAll} icon={CampaignsIcon} toggleExpandAll={toggleExpandAll} />
      <BuilderElements expandAll={expandAll} icon={DragAndDropIcon} toggleExpandAll={toggleExpandAll}/>
      {/* <MobilePages expandAll={expandAll} icon={MobilePageIcon} /> */}
      {/* <LeadCapture expandAll={expandAll} icon={LeadCaptureIcon} />
      <Library expandAll={expandAll} icon={LibraryIcon} />
      <AccountManagement expandAll={expandAll} icon={AccountManagementIcon} /> */}
    </SideBarMenuWrapper>
  )
}

export default SideBarMenu

const SideBarMenuWrapper = styled.ul`
  margin: 0;
`
